export default {
      id: "ic_punishment_2-usage",
      viewBox: "0 0 21 21",
      url: "/" + "images/icons.3.109.2.svg#ic_punishment_2-usage",
      toString: function () {
        return this.url;
      }
    }